export default {
  'pages.layouts.userLayout.title':
    '泳池数智化运营管理系统，国内领先的泳池智慧化体系，让游泳管理更智能',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入电话号码',
  'pages.login.username.required': '电话号码是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  'pages.goods.name': '商品名称',
  'pages.goods.nameprice': '商品价格',
  'pages.goods.nameInput': '请输入商品名称',
  'pages.goods.title.basicInfo': '基本信息',
  'pages.goods.title.create': '创建商品',
  'pages.goods.title.edit': '修改商品',
  'pages.goods.saleRange': '销售范围',
  'pages.goods.saleRange.child': '儿童卡',
  'pages.goods.saleRange.adult': '成人卡',
  'pages.goods.saleRange.elderly': '老年卡',
  'pages.goods.goodsStatus': '商品状态',
  'pages.goods.goodsStatus.onself': '销售中',
  'pages.goods.goodsStatus.offself': '已下架',
  'pages.goods.goodsType': '商品类型',
  'pages.goods.goodsType.single': '单次卡',
  'pages.goods.goodsType.multiple': '多次卡',
  'pages.goods.goodsType.circle': '周期卡',
  'pages.goods.goodsType.group': '组合卡',
  'pages.goods.goodsType.groupTeam': '组合卡(团体卡)',
  'pages.goods.inventory': '库存数量',
  'pages.goods.inventory.unit': '张/日',
  'pages.goods.useCount': '权益次数',
  'pages.goods.validDate': '有效日期',
  'pages.goods.autoOffself': '下架日期',
  'pages.goods.rightsDays': '权益天数',
  'pages.goods.rightsDays.unit': '自然日',
  'pages.goods.selectGoods': '选择商品',
  'pages.goods.tags': '标签',
  'pages.goods.picture': '介绍图片',
  'pages.goods.rights': '商品权益',
  'pages.goods.description': '商品说明',

  'pages.goods.label.price': '价格',
  'pages.goods.price': '价格设置',
  'pages.goods.price.ageGroup': '年龄组',
  'pages.goods.price.workerDay': '工作日',
  'pages.goods.price.holiday': '节假日',

  'pages.goods.title.useRule': '使用规则',
  'pages.goods.verifyWay': '核销方式',
  'pages.goods.avaPool': '可用泳池',
  'pages.goods.code': '二维码',
  'pages.goods.face': '人脸',
  'pages.goods.manul': '前台手动',

  'pages.goods.title.otherInfo': '其他信息',
  'pages.goods.serviceContent': '服务内容',
  'pages.goods.beforeBuy': '购前需知',
  'pages.goods.noticeItems': '注意事项',
  'pages.goods.refundPolicy': '退单规则',

  /** pages-pool-member 商品模块（与 pages.goods 文案一致） */
  'pages-pool-member.goods.name': '商品名称',
  'pages-pool-member.goods.nameprice': '商品价格',
  'pages-pool-member.goods.nameInput': '请输入商品名称',
  'pages-pool-member.goods.title.basicInfo': '基本信息',
  'pages-pool-member.goods.title.create': '创建商品',
  'pages-pool-member.goods.title.edit': '修改商品',
  'pages-pool-member.goods.saleRange': '销售范围',
  'pages-pool-member.goods.saleRange.child': '儿童卡',
  'pages-pool-member.goods.saleRange.adult': '成人卡',
  'pages-pool-member.goods.saleRange.elderly': '老年卡',
  'pages-pool-member.goods.goodsStatus': '商品状态',
  'pages-pool-member.goods.goodsStatus.onself': '销售中',
  'pages-pool-member.goods.goodsStatus.offself': '已下架',
  'pages-pool-member.goods.goodsType': '商品类型',
  'pages-pool-member.goods.goodsType.single': '单次卡',
  'pages-pool-member.goods.goodsType.multiple': '多次卡',
  'pages-pool-member.goods.goodsType.circle': '周期卡',
  'pages-pool-member.goods.goodsType.group': '组合卡',
  'pages-pool-member.goods.goodsType.groupTeam': '组合卡(团体卡)',
  'pages-pool-member.goods.inventory': '库存数量',
  'pages-pool-member.goods.inventory.unit': '张/日',
  'pages-pool-member.goods.useCount': '权益次数',
  'pages-pool-member.goods.validDate': '有效日期',
  'pages-pool-member.goods.autoOffself': '下架日期',
  'pages-pool-member.goods.rightsDays': '权益天数',
  'pages-pool-member.goods.rightsDays.unit': '自然日',
  'pages-pool-member.goods.selectGoods': '选择商品',
  'pages-pool-member.goods.tags': '标签',
  'pages-pool-member.goods.picture': '介绍图片',
  'pages-pool-member.goods.rights': '商品权益',
  'pages-pool-member.goods.description': '商品说明',
  'pages-pool-member.goods.label.price': '价格',
  'pages-pool-member.goods.price': '价格设置',
  'pages-pool-member.goods.price.ageGroup': '年龄组',
  'pages-pool-member.goods.price.workerDay': '工作日',
  'pages-pool-member.goods.price.holiday': '节假日',
  'pages-pool-member.goods.title.useRule': '使用规则',
  'pages-pool-member.goods.verifyWay': '核销方式',
  'pages-pool-member.goods.avaPool': '可用泳池',
  'pages-pool-member.goods.code': '二维码',
  'pages-pool-member.goods.face': '人脸',
  'pages-pool-member.goods.manul': '前台手动',
  'pages-pool-member.goods.title.otherInfo': '其他信息',
  'pages-pool-member.goods.serviceContent': '服务内容',
  'pages-pool-member.goods.beforeBuy': '购前需知',
  'pages-pool-member.goods.noticeItems': '注意事项',
  'pages-pool-member.goods.refundPolicy': '退单规则',

  'pages.appoint.buyNow.temp': '立即购买(临客)',
  'pages.appoint.buyNow.vip': '立即购买(会员)',
  'pages.appoint.appointUse': '预约使用',
  'pages.appoint.enterNow': '立即入场',
  'pages.appoint.id': '预约ID',
  'pages.appoint.swimmer': '游泳者',
  'pages.appoint.time': '预约时间',
  'pages.appoint.timeRange': '时间段',
  'pages.appoint.from': '预约来源',
  'pages.appoint.referGoods': '相关商品',
  'pages.appoint.referOrder': '相关订单',
  'pages.appoint.status': '状态',
  'pages.appoint.member': '预约会员',
  'pages.appoint.loginTime': '登记时间',
  'pages.appoint.enter': '入场',
  'pages.appoint.leave': '离场',
  'pages.appoint.cancel': '作废',
  'pages.appoint.name': '姓名',
  'pages.appoint.sex': '性别',
  'pages.appoint.emergencyContact': '紧急联系方式',
  'pages.appoint.addCustomer': '请填加客人',
  'pages.appoint.duplicateSwimmer': '该游泳者已被选择',
  'pages.appoint.buyNow': '立即购买',
  'pages.appoint.applyNow': '立即支付',
  'pages.appoint.bingRing': '绑定手环',
  'pages.appoint.rightId': '手环ID',

  /** pages-pool-member 预约/核销（与 pages.appoint.* 对齐） */
  'pages-pool-member.appoint.buyNow.temp': '立即购买(临客)',
  'pages-pool-member.appoint.buyNow.vip': '立即购买(会员)',
  'pages-pool-member.appoint.appointUse': '预约使用',
  'pages-pool-member.appoint.enterNow': '立即入场',
  'pages-pool-member.appoint.id': '预约ID',
  'pages-pool-member.appoint.swimmer': '游泳者',
  'pages-pool-member.appoint.time': '预约时间',
  'pages-pool-member.appoint.timeRange': '时间段',
  'pages-pool-member.appoint.from': '预约来源',
  'pages-pool-member.appoint.referGoods': '相关商品',
  'pages-pool-member.appoint.referOrder': '相关订单',
  'pages-pool-member.appoint.status': '状态',
  'pages-pool-member.appoint.member': '预约会员',
  'pages-pool-member.appoint.loginTime': '登记时间',
  'pages-pool-member.appoint.enter': '入场',
  'pages-pool-member.appoint.leave': '离场',
  'pages-pool-member.appoint.cancel': '作废',
  'pages-pool-member.appoint.name': '姓名',
  'pages-pool-member.appoint.sex': '性别',
  'pages-pool-member.appoint.emergencyContact': '紧急联系方式',
  'pages-pool-member.appoint.addCustomer': '请填加客人',
  'pages-pool-member.appoint.duplicateSwimmer': '该游泳者已被选择',
  'pages-pool-member.appoint.buyNow': '立即购买',
  'pages-pool-member.appoint.applyNow': '立即支付',
  'pages-pool-member.appoint.bingRing': '绑定手环',
  'pages-pool-member.appoint.rightId': '手环ID',
  'pages-pool-member.appoint.batchAddFailed': '批量添加失败',

  'pages-pool-member.member.label': '会员',

  'pages-pool-member.order.id': '订单ID',
  'pages-pool-member.order.name': '订单名称',
  'pages-pool-member.order.type': '订单类型',
  'pages-pool-member.order.referGoods': '相关商品',
  'pages-pool-member.order.amount': '金额',
  'pages-pool-member.order.payAmount': '支付金额',
  'pages-pool-member.order.payTime': '支付时间',
  'pages-pool-member.order.status': '状态',
  'pages-pool-member.order.isRefund': '是否存在退款',
  'pages-pool-member.order.refundAmount': '退款金额',
  'pages-pool-member.order.vip': '会员',
  'pages-pool-member.order.createTime': '创建时间',

  'pages.reconciliation.id': '订单ID',
  'pages.reconciliation.appointTime': '预约时间',
  'pages.reconciliation.timeRange': '时间段',
  'pages.reconciliation.orderFrom': '订单来源',
  'pages.reconciliation.referGoods': '相关商品',
  'pages.reconciliation.payType': '支付类型',
  'pages.reconciliation.payAmount': '支付金额',
  'pages.reconciliation.vip': '会员',
  'pages.reconciliation.createTime': '创建时间',
  'pages.reconciliation.payTime': '支付时间',
  'pages.reconciliation.date': '日期',
  'pages.reconciliation.saleAmount': '销售额',
  'pages.reconciliation.orderAmount': '销售额',
  'pages.reconciliation.orderTotal': '订单总数',
  'pages.reconciliation.onlineTotal': '线上业务量',
  'pages.reconciliation.offlineTotal': '线下业务量',
  'pages.reconciliation.payTotal': '支付单总数',
  'pages.reconciliation.cashPay': '现金支付',
  'pages.reconciliation.wechatPay': '微信支付',
  'pages.reconciliation.aliPay': '支付宝',
  'pages.reconciliation.cloudPay': '云闪付',
  'pages.reconciliation.card': '信用卡',
  'pages.reconciliation.singleSale': '单次卡售卖',
  'pages.reconciliation.singleAmount': '单次卡金额',
  'pages.reconciliation.multiSale': '多次卡售卖',
  'pages.reconciliation.multiAmount': '多次卡金额',
  'pages.reconciliation.circleSale': '周期卡售卖',
  'pages.reconciliation.circleAmount': '周期卡金额',
  'pages.reconciliation.comboSale': '组合卡售卖',
  'pages.reconciliation.comboAmount': '组合卡金额',

  'pages-pool-member.member.title': '会员',
  'pages-pool-member.member.aliasName': '昵称',
  'pages-pool-member.member.wechatid': '微信ID',
  'pages-pool-member.member.channel': '注册渠道',
  'pages-pool-member.member.name': '姓名',
  'pages-pool-member.member.gender': '性别',
  'pages-pool-member.member.phone': '电话',
  'pages-pool-member.member.idCard': '身份证',
  'pages-pool-member.member.nameStaus': '实名状态',
  'pages-pool-member.member.vipStatus': '会员状态',

  'pages.ring.id': '手环ID',

  'pages.common.createTime': '创建时间',
  'pages.common.updateTime': '更新时间',
  'pages.common.act': '操作',
  'pages.common.create': '创建',
  'pages.common.edit': '修改',
  'pages.common.serial': '序号',
  // Carousel (Operating)
  'pages.carousel.id': 'ID',
  'pages.carousel.name': '名称',
  'pages.carousel.image': '图片',
  'pages.carousel.position': '位置',
  'pages.carousel.linkType': '链接类型',
  'pages.carousel.linkUrl': '链接地址',
  'pages.carousel.target': '目标参数值',
  'pages.carousel.sort': '排序',
  'pages.carousel.status': '状态',
  'pages.carousel.create': '新建轮播图',
  'pages.carousel.edit': '编辑轮播图',
  'pages.carousel.name.required': '请输入名称',
  'pages.carousel.enable.confirm': '确定启用该轮播图？',
  'pages.carousel.disable.confirm': '确定禁用该轮播图？',
  'pages.carousel.delete.confirm': '确定删除该轮播图？',
  // Commons
  'pages.common.new': '新建',
  'pages.common.enable': '启用',
  'pages.common.disable': '禁用',
  'pages.common.delete': '删除',
  'pages.common.actions': '操作',
  'pages.common.success': '操作成功',
  'pages.common.deleted': '删除成功',
  'pages.common.saveSuccess': '保存成功',
  // Common aliases (for compatibility with code using enabled/disabled)
  'pages.common.enabled': '启用',
  'pages.common.disabled': '禁用',
  // ImageCropUpload component
  'pages.common.empty': '点击上传图片',
  'pages.common.upload': '裁剪上传',
  // Notice (Announcement)
  'pages.notice.title': '标题',
  'pages.notice.content': '内容',
  'pages.notice.status': '状态',
  'pages.notice.sort': '排序',
  'pages.notice.timeRange': '时间范围',
  'pages.notice.relList': '关联商品',
  'pages.notice.mobilePosition': '展示位置',
  'pages.notice.mobilePosition.home': '首页',
  'pages.notice.mobilePosition.goods': '商品详情页',
  'pages.notice.mobilePosition.order': '订单列表页',
  'pages.notice.createNotice': '新增通知',
  'pages.notice.detail': '详情',
  'pages.notice.publish': '发布',
  'pages.notice.terminate': '终止',
  'pages.notice.published': '已发布',
  'pages.notice.unpublished': '未发布',
  // Recommendation
  'pages.recommendation.create': '新增推荐',
  'pages.recommendation.edit': '编辑推荐',
  'pages.recommendation.enable.confirm': '确定启用该推荐？',
  'pages.recommendation.disable.confirm': '确定禁用该推荐？',
  'pages.recommendation.delete.confirm': '确定删除该推荐？',
  'pages.recommendation.sort': '排序',
  'pages.recommendation.timeRange': '时间范围',
  'pages.recommendation.goodsName': '商品名称',
  'pages.recommendation.goodsNameInput': '请选择商品',
  'pages.recommendation.goodsImage': '商品图片',
  'pages.recommendation.editBtn': '编辑',
  // System Dept
  'pages.system.dept.create': '新增部门',
  'pages.system.dept.edit': '编辑部门',
  'pages.system.dept.name': '部门名称',
  'pages.system.dept.name.required': '请输入部门名称',
  'pages.system.dept.parent': '上级部门',
  'pages.system.dept.maxLevel': '部门层级最多为3级',
  'pages.system.dept.disable.confirm': '确定禁用该部门？',
  'pages.system.dept.enable.confirm': '确定启用该部门？',
  'pages.system.dept.delete.confirm': '确认要删除该部门？',
  'pages.common.deleteFailed': '删除失败',
  'pages.common.saveFailed': '保存失败',
  'pages.common.cancel': '取消',
  'pages.common.confirm': '确定',
  'pages.common.pagination.total': '第 {start}-{end} 条 / 共 {total} 条',
  'pages.notice.create': '新建公告',
  'pages.notice.edit': '编辑公告',
  'pages.notice.enable.confirm': '确定启用该公告？',
  'pages.notice.disable.confirm': '确定禁用该公告？',
  'pages.notice.delete.confirm': '确定删除该公告？',
  'pages.notice.title.required': '请输入标题',
  'pages.notice.content.required': '请输入内容',

  'pages.notice.sortOrder': '排序',
  'pages.notice.createTime': '创建时间',
  'pages.notice.isActive': '是否启用',
  'pages.notice.active': '是',
  'pages.notice.inactive': '否',
  'pages.notice.terminate.confirm': '确定终止该通知？',
  'pages.notice.publish.confirm': '确定发布该通知？',
  'pages.notice.showStartTime': '生效时间',
  'pages.notice.showEndTime': '失效时间',
  // System Menu
  'pages.system.menu.create': '新增菜单',
  'pages.system.menu.edit': '编辑菜单',
  'pages.system.menu.name': '菜单名称',
  'pages.system.menu.name.required': '请输入菜单名称',
  'pages.system.menu.type': '类型',
  'pages.system.menu.code': '编码',
  'pages.system.menu.code.required': '请输入编码',
  'pages.system.menu.type.catalog': '目录',
  'pages.system.menu.type.menu': '菜单',
  'pages.system.menu.type.button': '按钮',
  'pages.system.menu.parent': '上级菜单',
  'pages.system.menu.path': '路由',
  'pages.system.menu.component': '组件路径',
  'pages.system.menu.icon': '图标',
  'pages.system.menu.order': '顺序',
  'pages.system.menu.import': '导入菜单',
  'pages.system.menu.downloadTemplate': '下载模板',
  'pages.system.menu.template.filename': '菜单导入模板',
  'pages.system.menu.template.download.success': '模板下载成功',
  'pages.system.menu.template.download.error': '模板下载失败，请重试',
  'pages.system.menu.import.button': '导入菜单',
  'pages.system.menu.import.success': '菜单导入成功',
  'pages.system.menu.import.error.fileType': '您只能上传Excel文件！',
  'pages.system.menu.import.error.fileSize': '文件必须小于10MB!',
  'pages.system.menu.import.error.import': '菜单导入失败',
  'pages.system.menu.import.error.network': '菜单导入失败，请检查网络连接',
  'pages.system.menu.currentVersion': '当前版本ID: {versionId}',
  'pages.system.menu.disable.confirm': '确定禁用该菜单？',
  'pages.system.menu.enable.confirm': '确定启用该菜单？',
  'pages.system.menu.maxLevel': '菜单层级最多为3级',
  'pages.system.menu.menu.requires': '菜单需填写路由与组件路径',
  'pages.system.menu.redirect': '重定向',
  'pages.system.menu.button.create': '新增按钮',
  'pages.system.menu.button.edit': '编辑按钮',
  'pages.system.menu.button.name': '按钮名称',
  'pages.system.menu.button.name.required': '请输入按钮名称',
  'pages.system.menu.button.code': '编码',
  'pages.system.menu.button.code.required': '请输入编码',
  'pages.system.menu.button.uiType': '按钮UI类型',
  'pages.system.menu.button.uiType.placeholder': '请选择按钮UI类型',
  'pages.system.menu.button.placement': '按钮位置',
  'pages.system.menu.button.placement.placeholder': '请选择按钮位置',
  'pages.system.menu.button.placement.required': '请选择按钮位置',
  'pages.system.menu.isHidden': '是否隐藏',
  'pages.system.menu.isHidden.no': '显示',
  'pages.system.menu.isHidden.yes': '隐藏',
  'pages.system.menu.description': '描述',
  'pages.system.menu.sortOrder': '顺序',
  'pages.system.menu.addMenu': '新增菜单',
  'pages.system.menu.buttonManagement': '按钮管理',
  'pages.system.menu.module': '模块',
  'pages.system.menu.menu': '菜单',
  'pages.system.menu.button': '按钮',
  'pages.system.menu.disable.confirm.title': '确定禁用该{type}？',
  'pages.system.menu.disable.confirm.content': '禁用后该{type}将不可使用',
  'pages.system.menu.enable.confirm.title': '确定启用该{type}？',
  'pages.system.menu.enable.confirm.content': '启用后该{type}将可以正常使用',
  'pages.system.menu.delete.confirm.title': '确定删除该{type}？',
  'pages.system.menu.delete.confirm.content':
    '删除后该{type}将无法恢复，请谨慎操作',

  // 权限版本管理
  'pages.system.permissionVersion.title': '版本管理',
  'pages.system.permissionVersion.create': '新增版本',
  'pages.system.permissionVersion.edit': '编辑版本',
  'pages.system.permissionVersion.versionName': '版本名称',
  'pages.system.permissionVersion.versionName.placeholder': '请输入版本名称',
  'pages.system.permissionVersion.versionName.required': '请输入版本名称',
  'pages.system.permissionVersion.versionName.maxLength':
    '版本名称不能超过50个字符',
  'pages.system.permissionVersion.versionCode': '版本号',
  'pages.system.permissionVersion.versionCode.placeholder': '请输入版本号',
  'pages.system.permissionVersion.versionCode.required': '请输入版本号',
  'pages.system.permissionVersion.status': '状态',
  'pages.system.permissionVersion.status.required': '请选择状态',
  'pages.system.permissionVersion.create.success': '创建成功',
  'pages.system.permissionVersion.create.error': '创建失败',
  'pages.system.permissionVersion.update.success': '更新成功',
  'pages.system.permissionVersion.update.error': '更新失败',
  'pages.system.permissionVersion.save.error': '保存失败，请重试',
  'pages.system.permissionVersion.delete.success': '删除成功',
  'pages.system.permissionVersion.delete.error': '删除失败',
  'pages.system.permissionVersion.delete.confirm.title': '删除确认',
  'pages.system.permissionVersion.delete.confirm.content':
    '确定要删除版本 "{name}" 吗？删除后无法恢复。',
  'pages.system.permissionVersion.status.update.success': '状态更新成功',
  'pages.system.permissionVersion.status.update.error': '状态更新失败',
  'pages.system.permissionVersion.list.error': '获取列表失败',
  'pages.system.permissionVersion.enable.confirm': '确定启用该版本？',
  'pages.system.permissionVersion.disable.confirm': '确定禁用该版本？',
  'pages.system.permissionVersion.menuManagement': '菜单管理',

  // 角色管理相关
  'pages.role.edit': '编辑角色',
  'pages.role.create': '新建角色',
  'pages.role.name': '角色名称',
  'pages.role.code': '角色编码',
  'pages.role.remark': '备注',
  'pages.role.status': '状态',
  'pages.role.systemRole': '系统角色',
  'pages.role.management': '角色管理',
  'pages.role.permissionConfig': '权限配置',
  'pages.role.enable': '启用',
  'pages.role.disable': '禁用',
  'pages.role.enable.confirm': '确定启用该角色？',
  'pages.role.disable.confirm': '确定禁用该角色？',
  'pages.role.delete.confirm': '确定删除该角色？',
  'pages.role.delete.content': '删除后不可恢复，请谨慎操作',
  'pages.role.name.required': '请输入角色名称',
  'pages.role.name.maxLength': '角色名称不能超过50个字符',
  'pages.role.name.placeholder': '请输入角色名称',
  'pages.role.code.required': '请输入角色编码',
  'pages.role.code.pattern': '角色编码只能包含字母、数字和下划线',
  'pages.role.code.maxLength': '角色编码不能超过50个字符',
  'pages.role.code.placeholder': '请输入角色编码',
  'pages.role.remark.placeholder': '请输入备注信息',
  'pages.role.status.enabled': '启用',
  'pages.role.status.disabled': '禁用',
  'pages.role.systemRole.yes': '是',
  'pages.role.systemRole.no': '否',
  'pages.role.fetchDept.failed': '获取部门数据失败',
  'pages.role.fetchDept.networkError': '获取部门数据失败，请检查网络连接',

  // 员工管理相关
  'pages.staff.edit': '编辑员工',
  'pages.staff.create': '新建员工',
  'pages.staff.name': '员工姓名',
  'pages.staff.phone': '手机号',
  'pages.staff.password': '密码',
  'pages.staff.role': '角色',
  'pages.staff.status': '状态',
  'pages.staff.management': '员工管理',
  'pages.staff.deptStructure': '部门列表',
  'pages.staff.passwordManagement': '密码管理',
  'pages.staff.delete.confirm': '确认删除',
  'pages.staff.delete.content': '确定要删除员工「{name}」吗？删除后不可恢复。',
  'pages.staff.delete.success': '删除成功',
  'pages.staff.delete.failed': '删除失败',
  'pages.staff.fetchDetail.failed': '获取员工详情失败',
  'pages.staff.fetchDept.failed': '获取部门数据失败',
  'pages.staff.fetchDept.networkError': '获取部门数据失败，请检查网络连接',
  'pages.staff.fetchRole.failed': '获取角色列表失败',
  'pages.staff.name.required': '请输入员工姓名',
  'pages.staff.name.placeholder': '请输入员工姓名',
  'pages.staff.name.maxLength': '员工姓名不能超过50个字符',
  'pages.staff.phone.required': '请输入手机号',
  'pages.staff.phone.placeholder': '请输入手机号',
  'pages.staff.phone.invalid': '请输入正确的手机号格式',
  'pages.staff.password.required': '请输入密码',
  'pages.staff.password.placeholder': '请输入密码',
  'pages.staff.password.noModify': '不修改请留空',
  'pages.staff.password.minLength': '密码至少6位',
  'pages.staff.role.placeholder': '请选择角色',
  'pages.staff.status.normal': '正常',
  'pages.staff.status.disabled': '禁用',
  'pages.staff.password.change': '修改密码',
  'pages.staff.password.new': '新密码',
  'pages.staff.password.new.required': '请输入新密码',
  'pages.staff.password.new.placeholder': '请输入新密码',
  'pages.staff.password.new.minLength': '密码至少6位',
  'pages.staff.password.new.maxLength': '密码不能超过20位',
  'pages.staff.password.confirm': '确认密码',
  'pages.staff.password.confirm.required': '请确认新密码',
  'pages.staff.password.confirm.placeholder': '请再次输入新密码',
  'pages.staff.password.confirm.mismatch': '两次输入的密码不一致',
  'pages.staff.password.update.success': '密码修改成功',
  'pages.staff.password.update.failed': '密码修改失败',
  'pages.staff.info.incomplete': '员工信息不完整',
  'pages.staff.unknownError': '未知错误',
  'pages.staff.role.required': '请选择角色',
  'pages.staff.roleAssign': '角色关联',
  'pages.staff.roleAssign.title': '角色分配',
  'pages.staff.roleAssign.success': '角色分配成功',
  'pages.staff.roleAssign.failed': '角色分配失败',
  'pages-pool-member.staff.deptList': '部门列表',

  /** pages-pool-member 通用 */
  'pages-pool-member.common.act': '操作',
  'pages-pool-member.common.actions': '操作',
  'pages-pool-member.common.edit': '编辑',
  'pages-pool-member.common.delete': '删除',
  'pages-pool-member.common.delete-success': '删除成功',
  'pages-pool-member.common.create-success': '保存成功',
  'pages-pool-member.common.create-failed': '保存失败',
  'pages-pool-member.common.clickToUpload': '点击选择图片',
  'pages-pool-member.common.empty': '暂无',
  'pages-pool-member.common.cancel': '取消',
  'pages-pool-member.common.confirm': '确认',
  'pages-pool-member.common.createTime': '创建时间',
  'pages-pool-member.common.success': '操作成功',
  'pages-pool-member.common.enabled': '启用',
  'pages-pool-member.common.disabled': '停用',
  'pages-pool-member.common.enable': '启用',
  'pages-pool-member.common.disable': '停用',
  'pages-pool-member.common.deleted': '已删除',
  'pages-pool-member.common.deleteFailed': '删除失败',
  'pages-pool-member.common.saveSuccess': '保存成功',
  'pages-pool-member.common.saveFailed': '保存失败',
  'pages-pool-member.common.new': '新建',
  'pages-pool-member.common.serial': '序号',
  'pages-pool-member.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages-pool-member.404.buttonText': '返回首页',
  'pages-pool-member.system.menu.module': '模块',
  'pages-pool-member.system.menu.menu': '菜单',

  /** pages-pool-member 场馆协议 */
  'pages-pool-member.space.protocol.create': '新建协议',
  'pages-pool-member.space.protocol.create-title': '新建协议',
  'pages-pool-member.space.protocol.update-title': '编辑协议',
  'pages-pool-member.space.protocol.agreement-type': '协议类型',
  'pages-pool-member.space.protocol.agreement-type-placeholder':
    '请选择协议类型',
  'pages-pool-member.space.protocol.agreement-type-required': '请选择协议类型',
  'pages-pool-member.space.protocol.user-agreement': '用户协议',
  'pages-pool-member.space.protocol.privacy-agreement': '隐私协议',
  'pages-pool-member.space.protocol.refund-agreement': '退款协议',
  'pages-pool-member.space.protocol.goods-agreement': '商品协议',
  'pages-pool-member.space.protocol.payment-agreement': '支付协议',
  'pages-pool-member.space.protocol.agreement-version': '协议版本',
  'pages-pool-member.space.protocol.agreement-version-placeholder':
    '请输入协议版本',
  'pages-pool-member.space.protocol.agreement-version-required':
    '请输入协议版本',
  'pages-pool-member.space.protocol.is-effective': '是否生效',
  'pages-pool-member.space.protocol.is-effective-placeholder': '请选择是否生效',
  'pages-pool-member.space.protocol.is-effective-required': '请选择是否生效',
  'pages-pool-member.space.protocol.valid': '生效',
  'pages-pool-member.space.protocol.invalid': '未生效',
  'pages-pool-member.space.protocol.create-time': '创建时间',
  'pages-pool-member.space.protocol.create-user': '创建人',
  'pages-pool-member.space.protocol.update-time': '更新时间',
  'pages-pool-member.space.protocol.update-user': '更新人',
  'pages-pool-member.space.protocol.content': '协议内容',
  'pages-pool-member.space.protocol.content-required': '请输入协议内容',
  'pages-pool-member.space.protocol.delete-confirm': '确定删除该协议吗？',

  /** pages-pool-member 订单列表 */
  'pages-pool-member.order.orderList.index.orderNumber': '订单号',
  'pages-pool-member.order.orderList.index.goodsType': '商品类型',
  'pages-pool-member.order.orderList.index.single': '单次卡',
  'pages-pool-member.order.orderList.index.package': '套餐卡',
  'pages-pool-member.order.orderList.index.period': '周期卡',
  'pages-pool-member.order.orderList.index.relatedGoods': '相关商品',
  'pages-pool-member.order.orderList.index.orderDate': '下单日期',
  'pages-pool-member.order.orderList.index.memberName': '会员姓名',
  'pages-pool-member.order.orderList.index.memberPhone': '会员手机号',
  'pages-pool-member.order.orderList.index.orderStatus': '订单状态',
  'pages-pool-member.order.orderList.index.amount': '订单金额',
  'pages-pool-member.order.orderList.index.paidAmount': '实付金额',
  'pages-pool-member.order.orderList.index.paymentType': '支付方式',
  'pages-pool-member.order.orderList.index.paymentTime': '支付时间',
  'pages-pool-member.order.orderList.index.paymentStatus': '支付状态',
  'pages-pool-member.order.orderList.index.hasRefund': '是否退款',
  'pages-pool-member.order.orderList.index.yes': '是',
  'pages-pool-member.order.orderList.index.no': '否',
  'pages-pool-member.order.orderList.index.refundAmount': '退款金额',
  'pages-pool-member.order.orderList.index.member': '会员',
  'pages-pool-member.order.orderList.index.createTime': '创建时间',
  'pages-pool-member.order.orderList.index.details': '详情',
  'pages-pool-member.order.orderList.index.offlineRefund': '线下退款',
  'pages-pool-member.order.orderList.index.exportDetails': '导出明细',

  /** pages-pool-member 订单详情 */
  'pages-pool-member.order.orderList.components.OrderInfo.orderDetails':
    '订单详情',
  'pages-pool-member.order.orderList.components.OrderInfo.basicInfo':
    '基本信息',
  'pages-pool-member.order.orderList.components.OrderInfo.orderId': '订单ID',
  'pages-pool-member.order.orderList.components.OrderInfo.orderNumber':
    '订单号',
  'pages-pool-member.order.orderList.components.OrderInfo.payOrderId':
    '支付单号',
  'pages-pool-member.order.orderList.components.OrderInfo.goodsCount':
    '商品数量',
  'pages-pool-member.order.orderList.components.OrderInfo.orderAmount':
    '订单金额',
  'pages-pool-member.order.orderList.components.OrderInfo.orderStatus':
    '订单状态',
  'pages-pool-member.order.orderList.components.OrderInfo.paymentStatus':
    '支付状态',
  'pages-pool-member.order.orderList.components.OrderInfo.createTime':
    '创建时间',
  'pages-pool-member.order.orderList.components.OrderInfo.remark': '备注',

  /** pages-pool-member 订单项 */
  'pages-pool-member.order.orderList.components.OrderItem.orderItemInfo':
    '订单项信息',
  'pages-pool-member.order.orderList.components.OrderItem.goodsName':
    '商品名称',
  'pages-pool-member.order.orderList.components.OrderItem.goodsDescription':
    '商品描述',
  'pages-pool-member.order.orderList.components.OrderItem.noDescription':
    '暂无描述',
  'pages-pool-member.order.orderList.components.OrderItem.unitPrice': '单价',
  'pages-pool-member.order.orderList.components.OrderItem.purchaseQuantity':
    '购买数量',
  'pages-pool-member.order.orderList.components.OrderItem.actualPayment':
    '实际支付',
  'pages-pool-member.order.orderList.components.OrderItem.swimmerName':
    '泳客姓名',
  'pages-pool-member.order.orderList.components.OrderItem.emergencyContact':
    '紧急联系人',
  'pages-pool-member.order.orderList.components.OrderItem.emergencyPhone':
    '紧急联系电话',

  /** pages-pool-member 支付订单列表 */
  'pages-pool-member.order.payOrderList.index.timeRange': '时间范围',
  'pages-pool-member.order.payOrderList.index.orderId': '支付单号',
  'pages-pool-member.order.payOrderList.index.paymentTime': '支付时间',
  'pages-pool-member.order.payOrderList.index.payStatus': '支付状态',
  'pages-pool-member.order.payOrderList.index.orderSource': '订单来源',
  'pages-pool-member.order.payOrderList.index.relatedGoods': '相关商品',
  'pages-pool-member.order.payOrderList.index.paymentType': '支付方式',
  'pages-pool-member.order.payOrderList.index.paymentAmount': '支付金额',
  'pages-pool-member.order.payOrderList.index.member': '会员',
  'pages-pool-member.order.payOrderList.index.createTime': '创建时间',
  'pages-pool-member.order.payOrderList.index.details': '详情',
  'pages-pool-member.order.payOrderList.index.exportDetails': '导出明细',

  /** pages-pool-member 支付订单详情 */
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payOrderDetails':
    '支付订单详情',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.basicInfoTitle':
    '基本信息',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.orderId':
    '订单ID',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.orderNo':
    '订单号',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.wxPayNo':
    '微信支付单号',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.createTime':
    '创建时间',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.updateTime':
    '更新时间',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.remark': '备注',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.paymentInfoTitle':
    '支付信息',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.totalPrice':
    '订单总金额',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payPrice':
    '实付金额',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payTypeName':
    '支付方式',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payStatusName':
    '支付状态',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.description':
    '支付描述',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payTime':
    '支付时间',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.orderType':
    '订单类型',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.memberName':
    '会员姓名',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payChannel':
    '支付渠道',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundInfoTitle':
    '退款信息',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundFee':
    '退款金额',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundTime':
    '退款时间',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundReason':
    '退款原因',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.goodsInfoTitle':
    '商品信息',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.goodsType':
    '商品类型',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.goodsName':
    '商品名称',

  /** pages-pool-member 会员列表 */
  'pages-pool-member.member.memberList.index.confirmEnable': '确认启用',
  'pages-pool-member.member.memberList.index.confirmDisable': '确认禁用',
  'pages-pool-member.member.memberList.index.okText': '确定',
  'pages-pool-member.member.memberList.index.cancelText': '取消',
  'pages-pool-member.member.memberList.index.enableSuccess': '启用成功',
  'pages-pool-member.member.memberList.index.enableFailed': '启用失败',
  'pages-pool-member.member.memberList.index.disableSuccess': '禁用成功',
  'pages-pool-member.member.memberList.index.disableFailed': '禁用失败',
  'pages-pool-member.member.memberList.index.nickname': '昵称',
  'pages-pool-member.member.memberList.index.wechatId': '微信ID',
  'pages-pool-member.member.memberList.index.status': '状态',
  'pages-pool-member.member.memberList.index.statusEnabled': '启用',
  'pages-pool-member.member.memberList.index.statusDisabled': '禁用',
  'pages-pool-member.member.memberList.index.lastLoginTime': '最后登录时间',
  'pages-pool-member.member.memberList.index.createTime': '创建时间',
  'pages-pool-member.member.memberList.index.action': '操作',
  'pages-pool-member.member.memberList.index.edit': '编辑',
  'pages-pool-member.member.memberList.index.detail': '详情',
  'pages-pool-member.member.memberList.index.balance': '余额',
  'pages-pool-member.member.memberList.index.recharge': '充值',
  'pages-pool-member.member.memberList.index.rechargeTitle': '会员充值',
  'pages-pool-member.member.memberList.index.rechargeAmount': '充值金额',
  'pages-pool-member.member.memberList.index.rechargeAmountRequired':
    '请输入充值金额',
  'pages-pool-member.member.memberList.index.rechargeReason': '发放原因',
  'pages-pool-member.member.memberList.index.rechargePaySet': '钱包类型',
  'pages-pool-member.member.memberList.index.rechargePaySetPlaceholder':
    '选填，例如福利卡',
  'pages-pool-member.member.memberList.index.rechargeSuccess': '充值成功',
  'pages-pool-member.member.memberList.index.enable': '启用',
  'pages-pool-member.member.memberList.index.disable': '禁用',
  'pages-pool-member.member.memberList.index.memberBalance': '会员余额',
  'pages-pool-member.member.memberList.index.currentBalance': '当前余额',

  /** pages-pool-member 会员创建 */
  'pages-pool-member.member.memberList.components.CreateMember.addMember':
    '新增会员',
  'pages-pool-member.member.memberList.components.CreateMember.createSuccess':
    '创建成功',
  'pages-pool-member.member.memberList.components.CreateMember.memberName':
    '会员姓名',
  'pages-pool-member.member.memberList.components.CreateMember.inputMemberName':
    '请输入会员姓名',
  'pages-pool-member.member.memberList.components.CreateMember.memberPhone':
    '会员手机号',
  'pages-pool-member.member.memberList.components.CreateMember.inputMemberPhone':
    '请输入会员手机号',
  'pages-pool-member.member.memberList.components.CreateMember.phoneFormatError':
    '手机号格式错误',
  'pages-pool-member.member.memberList.components.CreateMember.memberIdCard':
    '身份证号',
  'pages-pool-member.member.memberList.components.CreateMember.inputMemberIdCard':
    '请输入身份证号',
  'pages-pool-member.member.memberList.components.CreateMember.idCardFormatError':
    '身份证格式错误',
  'pages-pool-member.member.memberList.components.CreateMember.gender': '性别',
  'pages-pool-member.member.memberList.components.CreateMember.selectGender':
    '请选择性别',
  'pages-pool-member.member.memberList.components.CreateMember.male': '男',
  'pages-pool-member.member.memberList.components.CreateMember.female': '女',
  'pages-pool-member.member.memberList.components.CreateMember.unknown': '未知',

  /** pages-pool-member 会员编辑 */
  'pages-pool-member.member.memberList.components.UpdateMember.editMemberInfo':
    '编辑会员信息',
  'pages-pool-member.member.memberList.components.UpdateMember.nickname':
    '昵称',
  'pages-pool-member.member.memberList.components.UpdateMember.inputNickname':
    '请输入昵称',
  'pages-pool-member.member.memberList.components.UpdateMember.name': '姓名',
  'pages-pool-member.member.memberList.components.UpdateMember.inputName':
    '请输入姓名',
  'pages-pool-member.member.memberList.components.UpdateMember.phone': '手机号',
  'pages-pool-member.member.memberList.components.UpdateMember.inputPhone':
    '请输入手机号',
  'pages-pool-member.member.memberList.components.UpdateMember.idCard':
    '身份证号',
  'pages-pool-member.member.memberList.components.UpdateMember.inputIdCard':
    '请输入身份证号',
  'pages-pool-member.member.memberList.components.UpdateMember.birthday':
    '生日',
  'pages-pool-member.member.memberList.components.UpdateMember.selectBirthday':
    '请选择生日',
  'pages-pool-member.member.memberList.components.UpdateMember.address': '地址',
  'pages-pool-member.member.memberList.components.UpdateMember.inputAddress':
    '请输入地址',
  'pages-pool-member.member.memberList.components.UpdateMember.profile': '简介',
  'pages-pool-member.member.memberList.components.UpdateMember.inputProfile':
    '请输入简介',

  /** pages-pool-member 会员详情 */
  'pages-pool-member.member.memberList.components.MemberInfo.memberDetail':
    '会员详情',
  'pages-pool-member.member.memberList.components.MemberInfo.avatar': '头像',
  'pages-pool-member.member.memberList.components.MemberInfo.username':
    '用户名',
  'pages-pool-member.member.memberList.components.MemberInfo.no': '-',
  'pages-pool-member.member.memberList.components.MemberInfo.nickname': '昵称',
  'pages-pool-member.member.memberList.components.MemberInfo.realName': '姓名',
  'pages-pool-member.member.memberList.components.MemberInfo.phone': '手机号',
  'pages-pool-member.member.memberList.components.MemberInfo.gender': '性别',
  'pages-pool-member.member.memberList.components.MemberInfo.birthday': '生日',
  'pages-pool-member.member.memberList.components.MemberInfo.notSet': '未设置',
  'pages-pool-member.member.memberList.components.MemberInfo.idCard':
    '身份证号',
  'pages-pool-member.member.memberList.components.MemberInfo.certificateType':
    '证件类型',
  'pages-pool-member.member.memberList.components.MemberInfo.idCardType':
    '身份证',
  'pages-pool-member.member.memberList.components.MemberInfo.balance': '余额',
  'pages-pool-member.member.memberList.components.MemberInfo.points': '积分',
  'pages-pool-member.member.memberList.components.MemberInfo.bindBracelet':
    '绑定手环',
  'pages-pool-member.member.memberList.components.MemberInfo.notBind': '未绑定',
  'pages-pool-member.member.memberList.components.MemberInfo.namedStatus':
    '实名认证状态',
  'pages-pool-member.member.memberList.components.MemberInfo.named': '已认证',
  'pages-pool-member.member.memberList.components.MemberInfo.unnamed': '未认证',
  'pages-pool-member.member.memberList.components.MemberInfo.ranking': '排名',
  'pages-pool-member.member.memberList.components.MemberInfo.totalEntryCount':
    '累计入场次数',
  'pages-pool-member.member.memberList.components.MemberInfo.registerTime':
    '注册时间',
  'pages-pool-member.member.memberList.components.MemberInfo.lastPurchaseTime':
    '最近购买时间',
  'pages-pool-member.member.memberList.components.MemberInfo.lastEntryTime':
    '最近入场时间',
  'pages-pool-member.member.memberList.components.MemberInfo.createTime':
    '创建时间',
  'pages-pool-member.member.memberList.components.MemberInfo.updateTime':
    '更新时间',
  'pages-pool-member.member.memberList.components.MemberInfo.address': '地址',
  'pages-pool-member.member.memberList.components.MemberInfo.profile': '简介',

  /** pages-pool-member 游泳人员列表 */
  'pages-pool-member.member.swimmerList.index.name': '姓名',
  'pages-pool-member.member.swimmerList.index.gender': '性别',
  'pages-pool-member.member.swimmerList.index.isTrainStudent': '是否学员',
  'pages-pool-member.member.swimmerList.index.yes': '是',
  'pages-pool-member.member.swimmerList.index.no': '否',
  'pages-pool-member.member.swimmerList.index.faceImg': '人脸照片',
  'pages-pool-member.member.swimmerList.index.phone': '手机号',
  'pages-pool-member.member.swimmerList.index.idCard': '身份证号',
  'pages-pool-member.member.swimmerList.index.braceletNo': '手环号',
  'pages-pool-member.member.swimmerList.index.address': '地址',
  'pages-pool-member.member.swimmerList.index.emergencyContactName':
    '紧急联系人姓名',
  'pages-pool-member.member.swimmerList.index.emergencyContactPhone':
    '紧急联系人电话',
  'pages-pool-member.member.swimmerList.index.status': '状态',
  'pages-pool-member.member.swimmerList.index.statusEnabled': '启用',
  'pages-pool-member.member.swimmerList.index.statusDisabled': '禁用',
  'pages-pool-member.member.swimmerList.index.memberName': '会员姓名',
  'pages-pool-member.member.swimmerList.index.createTime': '创建时间',
  'pages-pool-member.member.swimmerList.index.orderTime': '到期时间',
  'pages-pool-member.member.swimmerList.index.vipName': '会员卡名称',
  'pages-pool-member.member.swimmerList.index.vipPhone': '会员卡手机号',
  'pages-pool-member.member.swimmerList.index.info': '详情',
  'pages-pool-member.member.swimmerList.index.viewPhoto': '查看照片',
  'pages-pool-member.member.swimmerList.index.confirmDelete':
    '确认删除该游泳人员吗？',
  'pages-pool-member.member.swimmerList.index.deleteSuccess': '删除成功',
  'pages-pool-member.member.swimmerList.index.delete': '删除',
  'pages-pool-member.member.swimmerList.index.confirmEnable':
    '确认启用该游泳人员吗？',
  'pages-pool-member.member.swimmerList.index.enableSuccess': '启用成功',
  'pages-pool-member.member.swimmerList.index.enable': '启用',
  'pages-pool-member.member.swimmerList.index.confirmDisable':
    '确认禁用该游泳人员吗？',
  'pages-pool-member.member.swimmerList.index.disableSuccess': '禁用成功',
  'pages-pool-member.member.swimmerList.index.disable': '禁用',

  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberPhone':
    '会员手机号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.correctMemberPhone':
    '请输入正确的会员手机号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberNotFound':
    '未找到该会员',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.addSwimmer':
    '新增游泳人员',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.createSuccess':
    '新增成功',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.search':
    '查询',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberNameLabel':
    '会员姓名',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberNicknameLabel':
    '会员昵称',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberPhoneLabel':
    '会员手机号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.swimmerName':
    '游泳人员姓名',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputSwimmerName':
    '请输入游泳人员姓名',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.swimmerPhone':
    '游泳人员手机号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputSwimmerPhone':
    '请输入游泳人员手机号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.swimmerIdCard':
    '游泳人员身份证号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputSwimmerIdCard':
    '请输入游泳人员身份证号',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.emergencyContactName':
    '紧急联系人姓名',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputEmergencyContactName':
    '请输入紧急联系人姓名',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.emergencyContactPhone':
    '紧急联系人电话',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputEmergencyContactPhone':
    '请输入紧急联系人电话',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.status':
    '状态',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.selectStatus':
    '请选择状态',

  'pages-pool-member.member.swimmerList.components.SwimmerInfo.name': '姓名',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.braceletNo':
    '手环号',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.gender': '性别',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.phone': '手机号',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.idCard':
    '身份证号',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.address': '地址',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.member': '会员',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.swimmerType':
    '游泳者类型',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.isTrainStudent':
    '是否学员',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.emergencyContact':
    '紧急联系人',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.emergencyContactPhone':
    '紧急联系人电话',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.status': '状态',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.statusEnabled':
    '启用',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.statusDisabled':
    '禁用',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.faceImage':
    '人脸照片',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.swimmerDetail':
    '游泳人员详情',

  'pages-pool-member.member.swimmerList.components.UpdateSwimmer.faceImageInfo':
    '上传人脸照片（支持 jpg/png，建议正脸清晰）',
  'pages-pool-member.member.swimmerList.components.UpdateSwimmer.editSuccess':
    '编辑成功',
};
